export const Shell = ({ ...props }) => {
  return <div className="flex h-dvh flex-col print:h-[inherit]" {...props} />;
};

Shell.displayName = "Shell";
